import React, { useEffect } from "react";
import YearRangeField from "./shared/YearRangeField";
import NotesField from "./shared/NotesField";
import ImageUploadSection from "./shared/ImageUploadSection";
import VariantsSection from "./shared/VariantsSection";
import AutocompleteInput from "../../components/AutocompleteInput";
import ItemPrivacyToggle from "./shared/ItemPrivacyToggle";
import "./CardFormShared.css";


export default function SportsCardForm({
  card,
  setCard,
  onSubmit,
  onCancel,
  imageFiles,
  setImageFiles,
  previews,
  setPreviews,
  existingImages,
  categories = [],
  subcategories = [],
  isEditing = false,
  isSubmitting = false,
}) {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCard((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const filteredSubcategories = subcategories
    .filter((sub) => String(sub.category_id) === String(card.category_id))
    .sort((a, b) => (b.item_count || 0) - (a.item_count || 0));

  useEffect(() => {
    if (isEditing && card.category_id && !card.subcategory_id) {
      const filtered = subcategories.filter(
        (sub) => String(sub.category_id) === String(card.category_id)
      );
      if (filtered.length === 1) {
        setCard((prev) => ({ ...prev, subcategory_id: filtered[0].id }));
      }
    }
  }, [isEditing, card.category_id, subcategories, setCard]);

  return (
    <form className="card-form hobbli-collector-form" onSubmit={onSubmit}>
      {card.category_id && (
        <div className="category-display">
          <strong>
            Category:{" "}
            {categories.find((c) => String(c.id) === String(card.category_id))?.name ||
              "Unknown"}
          </strong>
        </div>
      )}

      <label>Subcategory</label>
      <select
        name="subcategory_id"
        value={card.subcategory_id || ""}
        onChange={handleChange}
        disabled={!card.category_id || filteredSubcategories.length === 0}
        className="form-input"
      >
        <option value="">Select Subcategory</option>
        {filteredSubcategories.map((sub) => (
          <option key={sub.id} value={sub.id}>
            {sub.name} ({sub.item_count || 0})
          </option>
        ))}
      </select>

      <input
        name="card_number"
        placeholder="Card Number"
        value={card.card_number ?? ""}
        onChange={handleChange}
        className="form-input"
      />
      <YearRangeField card={card} setCard={setCard} />

      <AutocompleteInput
        name="brand"
        placeholder="Brand"
        value={card.brand ?? ""}
        onChange={handleChange}
        rpcName="fuzzy_brand_autocomplete"
        className="form-input"
      />
      <AutocompleteInput
        name="set_name"
        placeholder="Set"
        value={card.set_name ?? ""}
        onChange={handleChange}
        rpcName="fuzzy_set_autocomplete"
        className="form-input"
      />

      <input
        name="subset"
        placeholder="Subset / Insert"
        value={card.subset ?? ""}
        onChange={handleChange}
        className="form-input"
      />

      <AutocompleteInput
        name="suggested_name"
        placeholder="Card Name"
        value={card.suggested_name ?? ""}
        onChange={handleChange}
        rpcName="fuzzy_name_autocomplete"
        valueKey="name"
        className="form-input"
      />

      <VariantsSection card={card} setCard={setCard} />

      <label className="checkbox-label">
        <input
          type="checkbox"
          name="autographed"
          checked={Boolean(card.autographed)}
          onChange={handleChange}
        />
        Autographed
      </label>

      <label className="checkbox-label">
        <input
          type="checkbox"
          name="graded"
          checked={Boolean(card.graded)}
          onChange={handleChange}
        />
        Graded / Authenticated
      </label>

      {card.graded && (
        <div className="graded-fields">
          <input
            name="grading_company"
            placeholder="Grading Company"
            value={card.grading_company ?? ""}
            onChange={handleChange}
            className="form-input"
          />
          <input
            name="grade"
            placeholder="Item Grade"
            value={card.grade ?? ""}
            onChange={handleChange}
            className="form-input"
          />
          {card.autographed && (
            <input
              name="autograph_grade"
              placeholder="Auto Grade"
              value={card.autograph_grade ?? ""}
              onChange={handleChange}
              className="form-input"
            />
          )}
          <input
            name="cert_number"
            placeholder="Cert Number"
            value={card.cert_number ?? ""}
            onChange={handleChange}
            className="form-input"
          />
        </div>
      )}

      <input
        name="price_paid"
        placeholder="Purchase Price"
        value={card.price_paid ?? ""}
        onChange={handleChange}
        className="form-input"
      />

      <div className="hobbli-notes-section">


        <NotesField value={card.notes ?? ""} onChange={handleChange} />


      </div>

      <div className="hobbli-images-section">


        <ImageUploadSection
        imageFiles={imageFiles}
        setImageFiles={setImageFiles}
        previews={previews}
        setPreviews={setPreviews}
        existingImages={existingImages}
      />


      </div>

      <ItemPrivacyToggle card={card} setCard={setCard} />

      <div className="form-actions">
        <button type="submit" className="submit-btn" disabled={isSubmitting}>
          {isSubmitting
            ? isEditing
              ? "Saving…"
              : "Inserting…"
            : isEditing
            ? "Save Changes"
            : "Add Card"}
        </button>
        <button type="button" className="cancel-btn" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
}
